import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { optionsCivilite } from "../../../utils/selectOptions";
import Select from "../../UI/Select";

const InformationsProprietaire = ({
  formData,
  setFormData,
  proprietaireIndivision,
  setProprietaireIndivision,
  proprietairesIndivision,
  setProprietairesIndivision,
  page,
  inputFocus,
}) => {
  const [isEditProprietaire, setIsEditProprietaire] = useState(false);
  const [modalDataProprietaire, setModalDataProprietaire] = useState({});
  const [indexItemProprietaire, setIndexItemProprietaire] = useState(null);
  const [toggleForm, setToggleForm] = useState(false);

  const handleChangeProprietaire = ({ currentTarget }) => {
    const { name, value } = currentTarget;
    setProprietaireIndivision((values) => ({ ...values, [name]: value }));
  };

  const handleTrimValue = (event) => {
    const { name, value } = event.target;
    setProprietaireIndivision((values) => ({
      ...values,
      [name]: value.trim(),
    }));
  };

  const handleUpdateProprietaire = (index) => {
    setIndexItemProprietaire(index);
    toggleFormPro();
  };

  const handleAddProprietaire = () => {
    let error = false;
    const proInputs = document.querySelectorAll(".errorPro");
    proInputs.forEach((element) => {
      if (element.value === "") {
        error = true;
        element.classList.add("is-invalid");
      } else {
        element.classList.replace("is-invalid", "is-valid");
      }
    });
    if (isEditProprietaire === true && !error) {
      const updatedPro = [...proprietairesIndivision];
      updatedPro[indexItemProprietaire] = proprietaireIndivision;
      setProprietairesIndivision(updatedPro);
      setProprietaireIndivision({});
      setIndexItemProprietaire(null);
      setIsEditProprietaire(false);
      toggleFormPro();
    } else if (isEditProprietaire === false && !error) {
      setProprietairesIndivision([
        ...proprietairesIndivision,
        proprietaireIndivision,
      ]);
      setFormData({
        ...formData,
        proprietairesIndivision: proprietairesIndivision,
      });
      setProprietaireIndivision({});
      toggleFormPro();
    }
  };

  const handleDeleteProprietaire = (id) => {
    const deleteItem = proprietairesIndivision.filter((item) => item.id !== id);
    setProprietairesIndivision(deleteItem);
    setProprietaireIndivision({});
  };

  const toggleFormPro = () => {
    setToggleForm(!toggleForm);
    const btnPro = document.querySelector("#btnPro");
    if (!toggleForm) {
      btnPro.classList.add("d-none");
    } else {
      btnPro.classList.remove("d-none");
    }
  };

  useEffect(() => {
    setFormData({
      ...formData,
      proprietairesIndivision: proprietairesIndivision,
    });
  }, [proprietaireIndivision]);
  return (
    <>
      <p className="fw-bold mt-4">
        Veuillez indiquer l'identité des autres propriétaires (époux, épouse,
        enfants, partenaire, frère, soeur, ...)&nbsp;:
      </p>
      {formData.proprietairesIndivision &&
        formData.proprietairesIndivision.map((item, index) => (
          <div key={index}>
            <div
              className={
                isEditProprietaire === true && index === indexItemProprietaire
                  ? "alert alert-secondary d-flex align-items-center"
                  : "alert alert-success d-flex align-items-center"
              }
            >
              <div className="d-flex align-items-center w-50">
                {isEditProprietaire === true &&
                index === indexItemProprietaire ? null : (
                  <p className="m-0 p-2 fs-4">&#10004;</p>
                )}
                <span className="p-2">
                  {item.ProIndivCivilite}&nbsp;{item.ProIndivNom}&nbsp;
                  {item.ProIndivPrenom}
                </span>
              </div>
              {page < 5 && (
                <div className="w-50 d-flex justify-content-end">
                  {!toggleForm ? (
                    <span
                      className="p-2"
                      onClick={() => {
                        setProprietaireIndivision(item);
                        handleUpdateProprietaire(index);
                        setIsEditProprietaire(true);
                      }}
                    >
                      <i
                        className="btn-icon fas fa-edit fa-lg"
                        title="Editer"
                      ></i>
                    </span>
                  ) : null}
                  <span
                    className="p-2"
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal"
                    onClick={() => {
                      setModalDataProprietaire(item);
                      setIsEditProprietaire(false);
                    }}
                  >
                    <i
                      className="btn-icon far fa-trash-alt fa-lg"
                      title="Supprimer"
                    ></i>
                  </span>
                </div>
              )}
            </div>
            <div
              className="modal fade"
              id="exampleModal"
              tabIndex="-1"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
              item={item.id || null}
            >
              <div className="modal-dialog modal-lg modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header border-0">
                    <h5 className="modal-title">Confirmer la suppression</h5>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div className="modal-body">
                    <p>
                      Êtes-vous sur de vouloir supprimer le ou la proprietaire:{" "}
                      {modalDataProprietaire.ProIndivCivilite}{" "}
                      {modalDataProprietaire.ProIndivNom}{" "}
                      {modalDataProprietaire.ProIndivPrenom} ?
                    </p>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-outline-warning btn-md"
                      data-bs-dismiss="modal"
                    >
                      Annuler
                    </button>
                    <button
                      type="button"
                      className="btn btn-warning btn-md"
                      onClick={() =>
                        handleDeleteProprietaire(modalDataProprietaire.id)
                      }
                      data-bs-dismiss="modal"
                    >
                      Supprimer
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      {page < 5 && (
        <button
          type="button"
          id="btnPro"
          className="btn btn-warning"
          onClick={toggleFormPro}
        >
          Ajouter un propriétaire
        </button>
      )}
      {toggleForm ? (
        <div className={page === 5 && "d-none"}>
          <div className="position-relative p-4 pt-2 background--warning">
            <div className="row">
              <input
                className="d-none"
                type="text"
                defaultValue={(proprietaireIndivision.id = uuidv4())}
              />
              <div className="col-12 col-md-2">
                <Select
                  label="Civilité :"
                  selectClassName={"errorPro"}
                  name="ProIndivCivilite"
                  value={proprietaireIndivision.ProIndivCivilite || ""}
                  handleChange={handleChangeProprietaire}
                  inputFocus={inputFocus}
                  options={optionsCivilite}
                />
              </div>
              <div className="col-12 col-md-5 position-relative">
                <label htmlFor="ProIndivPrenom" className="form-label">
                  Prénom&nbsp;:&nbsp;
                  <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control errorPro getLabel"
                  name="ProIndivPrenom"
                  id="ProIndivPrenom"
                  maxLength={30}
                  value={proprietaireIndivision.ProIndivPrenom || ""}
                  onChange={handleChangeProprietaire}
                  onInput={inputFocus}
                  onBlur={handleTrimValue}
                  autoComplete="nope"
                />
                <div className="invalid-tooltip">
                  Veuillez remplir ce champs obligatoire
                </div>
              </div>
              <div className="col-12 col-md-5 position-relative">
                <label htmlFor="ProIndivNom" className="form-label">
                  Nom de famille&nbsp;:&nbsp;
                  <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control errorPro getLabel"
                  name="ProIndivNom"
                  id="ProIndivNom"
                  maxLength={30}
                  value={proprietaireIndivision.ProIndivNom || ""}
                  onChange={handleChangeProprietaire}
                  onInput={inputFocus}
                  onBlur={handleTrimValue}
                  autoComplete="nope"
                />
                <div className="invalid-tooltip">
                  Veuillez remplir ce champs obligatoire
                </div>
              </div>
            </div>
            <div className="col-12 pt-3 position-relative">
              <label htmlFor="ProIndivRaisonSos" className="form-label">
                Dénomination et/ou raison sociale de sa société{" "}
                <span className="text-danger">(facultatif)</span>&nbsp;:&nbsp;
              </label>
              <input
                type="text"
                className="form-control getLabel"
                name="ProIndivRaisonSos"
                id="ProIndivRaisonSos"
                maxLength={50}
                value={proprietaireIndivision.ProIndivRaisonSos || ""}
                onChange={handleChangeProprietaire}
                onInput={inputFocus}
                onBlur={handleTrimValue}
                autoComplete="nope"
              />
            </div>
            <div className="d-flex justify-content-center mt-4">
              {isEditProprietaire === false ? (
                <button
                  type="button"
                  className="btn btn-outline-warning me-4"
                  onClick={toggleFormPro}
                >
                  Fermer
                </button>
              ) : null}
              {isEditProprietaire ? (
                <button
                  type="button"
                  className="btn btn-warning btn-md"
                  onClick={handleAddProprietaire}
                >
                  Modifier le ou la propriétaire
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-warning btn-md"
                  onClick={handleAddProprietaire}
                >
                  Enregistrer le ou la propriétaire
                </button>
              )}
            </div>
          </div>
        </div>
      ) : null}
      {page < 5 ? null : (
        <div className="position-relative p-4 pt-2 background--warning mt-4">
          <div className="row">
            <input
              className="d-none"
              type="text"
              defaultValue={(proprietaireIndivision.id = uuidv4())}
            />
            <div className="col-12 col-md-2">
              <Select
                label="Civilité :"
                selectClassName={"errorPro"}
                name="ProIndivCivilite"
                value={proprietaireIndivision.ProIndivCivilite || ""}
                handleChange={handleChangeProprietaire}
                inputFocus={inputFocus}
                options={optionsCivilite}
              />
            </div>
            <div className="col-12 col-md-5 position-relative">
              <label htmlFor="ProIndivPrenom" className="form-label">
                Prénom&nbsp;:&nbsp;<span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control errorPro getLabel"
                name="ProIndivPrenom"
                id="ProIndivPrenom"
                maxLength={30}
                value={proprietaireIndivision.ProIndivPrenom || ""}
                onChange={handleChangeProprietaire}
                onInput={inputFocus}
                onBlur={handleTrimValue}
              />
            </div>
            <div className="col-12 col-md-5 position-relative">
              <label htmlFor="ProIndivNom" className="form-label">
                Nom de famille&nbsp;:&nbsp;
                <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control errorPro getLabel"
                name="ProIndivNom"
                id="ProIndivNom"
                maxLength={30}
                value={proprietaireIndivision.ProIndivNom || ""}
                onChange={handleChangeProprietaire}
                onInput={inputFocus}
                onBlur={handleTrimValue}
              />
            </div>
          </div>
          <div className="col-12 pt-3 position-relative">
            <label htmlFor="ProIndivRaisonSos" className="form-label">
              Dénomination et/ou raison sociale de sa société&nbsp;
              <span className="text-danger">(facultatif)</span>&nbsp;:
            </label>
            <input
              type="text"
              className="form-control getLabel"
              name="ProIndivRaisonSos"
              id="ProIndivRaisonSos"
              maxLength={50}
              value={proprietaireIndivision.ProIndivRaisonSos || ""}
              onChange={handleChangeProprietaire}
              onInput={inputFocus}
              onBlur={handleTrimValue}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default InformationsProprietaire;
